import { render, staticRenderFns } from "./OuterFormConfig.vue?vue&type=template&id=6927a91c&scoped=true"
import script from "./OuterFormConfig.vue?vue&type=script&lang=js"
export * from "./OuterFormConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6927a91c",
  null
  
)

export default component.exports